import './App.css';
import { useRoutes } from "react-router-dom";
import { routes } from './config/Route';
import { AuthProvider } from './context/AuthContext';
import './utils/pwaInitializer';
// Keep AlertDisplay for testing if you want
// import AlertDisplay from './components/ui-components/AlertDisplay';

function App() {
  const routeElement = useRoutes(routes);

  return (
    <AuthProvider>
      {routeElement}
    </AuthProvider>
  );
}

export default App;
